import { Component, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'checkmark-item',
})
export class SignetCheckmarkItem {
   /**
   * Indicates if the item is valid or not.
   * @example true
   */
  @Prop() isValid: boolean;
  /**
   * Indicates if the item is active or not.
   * @example true
   */
  @Prop() isActive: boolean;

  @Element() el!: HTMLElement;

  render() {
    const classes = {
      'checkmark-item': true,
      valid: this.isValid,
      active: this.isActive,
    };

    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: {
        isValid: this.isValid,
        isActive: this.isActive
      }
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: {
        isValid: this.isValid,
        isActive: this.isActive
      }
    }));

    return (
      <li class={classes}>
        <slot></slot>
      </li>
    );
  }
}
